import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'
import {
  Button,
  Flex,
  type SkeletonProps,
  NumberInput,
  type NumberInputProps,
  Skeleton,
  Select,
  type SelectProps,
} from '@mantine/core'

import { Icon } from '@flecto/ui'

import { useTaxesInfo } from '../../../taxes'

type InputTaxesSelectorProps = (
  | Omit<SelectProps, 'data' | 'value' | 'onChange'>
  | Omit<NumberInputProps, 'value' | 'onChange'>
) & {
  value?: string | number
  onChange?: (value: string) => void
  withInlineOptions?: boolean
}

export function InputTaxesSelector(props: InputTaxesSelectorProps) {
  const { brackets, isLoading } = useTaxesInfo()

  if (isLoading) {
    return <Skeleton height={42} radius={100} {...(props as SkeletonProps)} />
  }

  if (brackets.length && props.withInlineOptions) {
    return (
      <Flex gap='md' wrap='wrap'>
        {brackets.map((bracket) => {
          const isChecked = props.value === bracket.value
          const icon = isChecked ? <Icon icon={faCheck} /> : null

          return (
            <Button
              key={`tax-rate-${bracket.value}-${bracket.percentage}`}
              leftSection={icon}
              size='sm'
              variant={isChecked ? 'outline' : 'default'}
              onClick={() => props.onChange?.(bracket.value)}
            >
              {bracket.label}
            </Button>
          )
        })}
      </Flex>
    )
  }

  if (!brackets.length) {
    return (
      <NumberInput
        leftSection='%'
        {...(props as NumberInputProps)}
        value={Number.isNaN(Number(props.value)) ? 0 : Number(props.value) / 10}
        onChange={(value) => props.onChange?.(String(Number(value) * 10))}
      />
    )
  }

  return <Select {...(props as SelectProps)} data={brackets} />
}
